import React from 'react';
import { UserProvider } from './userContext';
import { ApiProvider } from './apiContext';
import { SocketProvider } from './socketContext';
import { SubdomainProvider } from './subdomainContext';
import { ChatDrawerProvider } from './chatDrawerContext';

const ContextProvider = ({ children }) => {
    return (
        <SubdomainProvider>
            <UserProvider>
                <SocketProvider>
                    <ApiProvider>
                        {/* ChatDrawerProvider must sit inside Socket + Api + User
                            providers because the inline chat drawer it renders
                            depends on all three. */}
                        <ChatDrawerProvider>{children}</ChatDrawerProvider>
                    </ApiProvider>
                </SocketProvider>
            </UserProvider>
        </SubdomainProvider>
    );
};

export default ContextProvider;
